<template>
    <div :class="['checkout', config.platform, mode]">
        <cart-nav
            :options="[
                $t('cart_nav.choose_plan'),
                $t('cart_nav.confirm_details'),
                $t('cart_nav.complete'),
            ]"
            :active="cartIndex"
        />
        <div class="checkout-container">
            <reo-page-title
                v-if="isMobile"
                :title="$t('cart_nav.confirm_details')"
            />

            <reo-processing class="processing" v-if="querying" />
            <div
                class="payment-methods-container reo-payment-methods-container"
                v-else
            >
                <div class="title">
                    <h2 class="main-title">{{ $t("pay.choose_method") }}</h2>
                    <p class="des">{{ $t("pay.choose_method_des") }}</p>
                </div>
                <template v-for="paymentMethod in sort">
                    <!-- Paypal -->
                    <div
                        @click="handleSendEvent"
                        class="paypal-container"
                        v-show="paypalEnable"
                        v-if="paymentMethod === 'paypal'"
                        :key="paymentMethod"
                    >
                        <reo-processing
                            class="processing"
                            v-show="!paypalInit"
                        />
                        <div
                            id="smart-button-payment"
                            v-show="paypalInit"
                        ></div>
                    </div>

                    <!-- Payoneer -->
                    <div
                        class="payoneer-container"
                        v-if="payoneerEnable && paymentMethod === 'payoneer'"
                        v-show="payoneerInit"
                        :key="paymentMethod"
                    >
                        <div
                            class="initBtn-container"
                            :class="{ showPayoneer: payoneerShow }"
                        >
                            <button
                                id="initPayoneerBtn"
                                class="ui-button primary-button"
                                @click="showPayoneer"
                            >
                                <img :src="creditCardImg" /><span
                                    class="text"
                                >{{ $t("pay.payoneer_credit_card") }}</span
                                >
                            </button>
                        </div>
                        <div v-show="payoneerInit && payoneerShow">
                            <div id="payoneer-container"></div>
                            <div
                                id="paymentNetworksId"
                                class="payment-networks-container"
                            ></div>
                            <div v-if="payoneerError" class="error red">
                                {{ payoneerError }}
                            </div>

                            <div
                                id="submitBtnContainerId"
                                class="submit-buttons-container"
                            >
                                <button
                                    id="submitBtnId"
                                    type="button"
                                    class="ui-button primary-button"
                                ></button>
                            </div>
                            <p class="power-by payoneer">
                                {{ $t("pay.powerBy_payoneer") }}
                            </p>
                        </div>
                    </div>
                    <template
                        v-if="
                            adyenEnable &&
                                paymentMethod.startsWith('adyen') &&
                                !adyenDisabledTypes.includes(
                                    getAdyenType(paymentMethod)
                                )
                        "
                    >
                        <div
                            :id="`reo-adyen-${getAdyenType(paymentMethod)}`"
                            :key="`reo-adyen-${getAdyenType(paymentMethod)}`"
                            :payment-type="getAdyenType(paymentMethod)"
                            class="adyen-container"
                        />
                    </template>
                </template>
            </div>
            <cart-bottom v-if="config.platform === 'web'"></cart-bottom>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import router from '@/router';
import nprogress from 'nprogress';
import { config } from 'CONFIG';
import { AxiosError } from 'axios';
import {
    payment as orderPaymentStatus,
    currStage as currentStage,
} from '@/config/status';
import { getOrderDetailById, getPlanById } from '@/api/cart';
import {
    createPayment,
    approval,
    queryPaymentResult,
    cancelPayment,
} from '@/api/payment';
import { unfoldError } from '@/common/js/notice';
import { creditCardImg } from '@/common/images/common/payment';
import CartNav from '@/components/cartNav.vue';
import CartBottom from '@/components/cartBottom.vue';
import PaymentSDK from '@reolink-web/payment-sdk';
import { payManager } from '@/lib/payManager';
import {
    IOrder,
    IOrderItem,
    EPaymentSessionStatus,
    ESubscribeMode,
    ESeriesCategory,
    EPaymentMethod,
} from '@reolink-cloud/interface';
import { productsManager, uidHandler } from '@/lib';
import ReoPageTitle from '@/components/ReoPageTitle.vue';
import ReoProcessing from '@/basic/processing.vue';
import { Async } from '@reolink-web/utils';
import { Route } from 'vue-router';
import { singleRun } from '@/utils/run';
import reolinkGa from '@/common/js/gtagPageview';
import { apmMonitor } from '@/service/apmMonitor';
import { EApmTransactionType } from '@/config/apm';

const PAYPAL_MAX_RESTART_TIME = 3;
export default Vue.extend({
    components: {
        CartNav,
        CartBottom,
        ReoPageTitle,
        ReoProcessing,
    },
    data() {

        let mode = ( this.$route.query.mode ?? '' ) as string;
        let orderId = ( this.$route.query.o_id ?? '' ) as string;
        let prevPlan = ( this.$route.query.pp_id ?? '0' ) as string;
        let redirectUrl = `/checkout/payment-complete/?id={id}&result={result}&platform=${config.platform}&mode=${mode}&pp_id=${prevPlan}`;

        return {
            cartIndex: 1,
            config,
            mode,
            orderId,
            orderObj: {} as IOrder,
            orderItems: {} as IOrderItem,
            prevPlan,
            redirectUrl,
            creditCardImg,
            orderPaymentStatus,
            EPaymentSessionStatus,
            currentStage,
            orderPreviewInit: false,
            paypalInit: false,
            interval: 0,
            timer: null as null | number,
            paypalSessionId: '',
            paypalEnable: false,
            paymentSDK: null as null | PaymentSDK,
            querying: false,
            orderStatus: '',
            paySessionStatus: '',
            paypalRestartTime: 0,
            popStateCb: null as
                | (( this: Window, ev: PopStateEvent ) => any )
                | null,
            payError: '',
            payoneerEnable: false,
            payoneerSessionId: '',
            payoneerInst: null,
            payoneerShow: false,
            payoneerInit: false,
            payoneerError: '',
            adyenEnable: false,
            adyenInit: false,
            sort: [] as string[],
            adyenDisabledTypes: [] as string[],
            currentPopState: false,
            adyenClickHandler: null as Function | null,
        };

    },
    created() {

        // 监听Adyen支付方法的点击事件
        this.setupAdyenClickListeners();

    },
    async mounted() {

        this.popStateListener();
        this.orderId = ( this.$route.query.o_id ?? '' ) as string;

        await productsManager.update({ lang: this.lang });

        await this.initOrderDetails();
        this.handlePayoneerData = singleRun( this.handlePayoneerData );

        try {

            if (
                this.orderObj.status.paymentStatus ===
                orderPaymentStatus.CREATED
            ) {

                this.orderStatus = orderPaymentStatus.CREATED;
                await this.getPaymentMethodStatus();
                await this.initPaymentSDK();
                this.orderCompleteListener();

            } else {

                this.goCompletePage();

            }

        } finally {

            nprogress.done();

        }

    },
    beforeDestroy() {

        payManager.cleanup();
        this.adyenDisabledTypes = [];

    },
    methods: {
        showPayoneer() {

            reolinkGa.sendSimpleEvent( `${this.currentPlanTypeSuffer}-Pay` );
            this.payoneerShow = !this.payoneerShow;

        },

        async createPayoneerSession() {

            try {

                const response = await createPayment({
                    order: this.orderId,
                    redirectUrl: this.redirectUrl,
                    paymentMethod: EPaymentMethod.PAYONEER,
                    lang: this.lang,
                });
                return {
                    url: response.url,
                    sessionId: response.sessionId,
                };

            } catch ( error ) {

                console.error( 'Error creating Payoneer session:', error );
                throw error;

            }

        },

        handleSendEvent() {

            reolinkGa.sendSimpleEvent( `${this.currentPlanTypeSuffer}-Pay` );

        },

        setupAdyenClickListeners() {

            // 创建MutationObserver来监听Adyen容器内DOM变化
            const observerMap = new Map();

            // 处理Adyen按钮点击事件的函数
            const handleAdyenButtonClick = () => {

                // 发送GA统计事件
                reolinkGa.sendSimpleEvent(
                    `${this.currentPlanTypeSuffer}-Pay`
                );

            };

            // 为Adyen容器中的按钮添加点击事件监听器
            const addClickListenersToAdyenButtons = ( container: Element ) => {

                const paymentType = container.getAttribute( 'payment-type' );
                if ( !paymentType ) return;

                // 查找容器内所有可点击的元素
                const clickableElements = container.querySelectorAll(
                    'button, [role="button"], .adyen-checkout__button, .adyen-checkout__payment-method, [data-cse], input[type="submit"], .adyen-checkout__card, .adyen-checkout__payment-method--selected'
                );

                for ( const element of clickableElements ) {

                    // 检查是否已经添加过监听器
                    if ( !element.hasAttribute( 'data-adyen-click-listener' )) {

                        element.setAttribute(
                            'data-adyen-click-listener',
                            'true'
                        );
                        element.addEventListener(
                            'click',
                            () => {

                                handleAdyenButtonClick( paymentType );

                            },
                            { capture: true }
                        ); // 使用capture确保事件优先触发

                    }

                }

            };

            // 创建MutationObserver监听DOM变化
            const createObserverForContainer = ( container: Element ) => {

                const observer = new MutationObserver(( mutations ) => {

                    let shouldCheckForButtons = false;

                    for ( const mutation of mutations ) {

                        if (
                            mutation.type === 'childList' &&
                            mutation.addedNodes.length > 0
                        ) {

                            shouldCheckForButtons = true;

                        }

                    }

                    if ( shouldCheckForButtons ) {

                        // 延迟一下确保DOM完全渲染
                        setTimeout(() => {

                            addClickListenersToAdyenButtons( container );

                        }, 100 );

                    }

                });

                observer.observe( container, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['class', 'data-cse'],
                });

                return observer;

            };

            // 监听所有现有的Adyen容器
            const setupObserversForExistingContainers = () => {

                const adyenContainers =
                    document.querySelectorAll( '.adyen-container' );
                for ( const container of adyenContainers ) {

                    const observer = createObserverForContainer( container );
                    observerMap.set( container, observer );

                    // 立即检查已有的按钮
                    addClickListenersToAdyenButtons( container );

                }

            };

            // 监听页面中新增的Adyen容器
            const documentObserver = new MutationObserver(( mutations ) => {

                for ( const mutation of mutations ) {

                    for ( const node of mutation.addedNodes ) {

                        if ( node.nodeType === Node.ELEMENT_NODE ) {

                            const element = node as Element;
                            // 检查新增的元素是否是Adyen容器
                            if (
                                element.classList?.contains( 'adyen-container' )
                            ) {

                                const observer =
                                    createObserverForContainer( element );
                                observerMap.set( element, observer );
                                setTimeout(() => {

                                    addClickListenersToAdyenButtons( element );

                                }, 100 );

                            }
                            // 检查新增元素的子元素中是否有Adyen容器
                            const childAdyenContainers =
                                element.querySelectorAll?.( '.adyen-container' );
                            for ( const container of childAdyenContainers ) {

                                if ( !observerMap.has( container )) {

                                    const observer =
                                        createObserverForContainer( container );
                                    observerMap.set( container, observer );
                                    setTimeout(() => {

                                        addClickListenersToAdyenButtons(
                                            container
                                        );

                                    }, 100 );

                                }

                            }

                        }

                    }

                }

            });

            documentObserver.observe( document.body, {
                childList: true,
                subtree: true,
            });

            // 立即设置现有容器的观察器
            setupObserversForExistingContainers();

            // 定期检查（兜底机制）
            const intervalId = setInterval(() => {

                setupObserversForExistingContainers();

            }, 2000 );

            // 保存清理函数
            this.adyenClickHandler = () => {

                for ( const observer of observerMap ) {

                    observer.disconnect();

                }

                observerMap.clear();
                documentObserver.disconnect();
                clearInterval( intervalId );

            };

        },

        async getPaymentMethodStatus() {

            const { paypal, payoneer, adyen } =
                await payManager.getPaymentsMethodsStatus({
                    'order-id': this.orderId,
                });
            this.paypalEnable = paypal.enabled;
            this.payoneerEnable =
                payoneer.enabled &&
                ( payoneer.style?.availableCountries ?? [] ).includes(
                    this.orderObj.payer.country
                );
            this.adyenEnable = adyen.enabled;
            this.sort = payManager.sort;

        },

        async initPaymentSDK() {

            // 获取支付网关状态与创建支付会话分开。
            const { paypal, payoneer } = await payManager.initPaymentSDK2Pay(
                {
                    order: this.orderId,
                    redirectUrl: this.redirectUrl,
                    lang: this.lang,
                },
                {
                    orderExpiredCb: () => {

                        unfoldError( 'order_complete.fail_reason2', 999999 );
                        this.goCompletePage();

                    },
                    totalFailedCb: () => {

                        unfoldError( 'errors.network_error', 999999 );

                    },
                }
            );

            this.paypalSessionId = paypal.sessionId;
            this.payoneerSessionId = payoneer.sessionId;

            if ( this.paypalEnable ) {

                try {

                    await payManager.initPaypal2Pay({
                        buyerCountry: this.orderObj.payer.country,
                        currency: this.orderObj.currency,
                    });

                    await payManager.renderPaypal(
                        {
                            onApproveData: async ( data, actions ) => {

                                apmMonitor.startOrRenameTransaction(
                                    this.transactionNames.LEVEL1_ORDER_PAY_PAYPAL,
                                    EApmTransactionType.PAYMENT_PROCESS
                                );

                                try {

                                    let { status, redirectUrl } =
                                        await approval( this.paypalSessionId );
                                    this.paySessionStatus = status;
                                    this.redirectUrl = redirectUrl;
                                    await this.statusHandle(
                                        this.paypalSessionId
                                    );

                                } catch ( err ) {

                                    const symbol = ( err as AxiosError ).response
                                        ?.data.error.symbol;
                                    if ( symbol === 'order_expired' ) {

                                        unfoldError(
                                            'order_complete.fail_reason2',
                                            999999
                                        );
                                        this.goCompletePage();

                                    } else if (
                                        symbol === 'cannot_capture_payment'
                                    ) {

                                        let reason = ( err as AxiosError )
                                            .response?.data.error.metadata
                                            .reason;
                                        if (
                                            reason === 'instrument declined' &&
                                            this.paypalRestartTime <
                                                PAYPAL_MAX_RESTART_TIME
                                        ) {

                                            this.paypalRestartTime++;
                                            actions?.restart();

                                        } else {

                                            this.payError = reason;
                                            await this.statusHandle(
                                                this.paypalSessionId
                                            );

                                        }

                                    } else {

                                        unfoldError(
                                            'errors.network_error',
                                            999999
                                        );

                                    }

                                }

                            },
                            onError: ( error, msg, errorWatcherData ) => {

                                apmMonitor.startOrRenameTransaction(
                                    this.transactionNames.LEVEL1_ORDER_PAY_PAYPAL,
                                    EApmTransactionType.PAYMENT_PROCESS
                                );

                                console.error(
                                    error,
                                    msg,
                                    errorWatcherData?.error
                                );

                                if ( window.location.pathname.includes( 'pay' )) {

                                    unfoldError(
                                        this.$t(
                                            'errors.network_error'
                                        ) as string,
                                        5000
                                    );

                                }

                            },
                            onClick: () => {

                                reolinkGa.sendSimpleEvent(
                                    `${this.currentPlanTypeSuffer}-Pay`
                                );

                            },
                            style: {
                                color: 'gold', // gold | blue | silver
                                shape: 'rect', // pill | rect
                                layout: 'vertical',
                                height: 46,
                            },
                        },
                        '#smart-button-payment'
                    );

                    this.paypalInit = true;

                } catch ( e ) {

                    console.error( e );
                    unfoldError( 'errors.network_error', 999999 );

                }

            }

            // Initialize Payoneer if enabled
            if ( this.payoneerEnable ) {

                try {

                    payManager.createPayoneerInstance();
                    await payManager.initPayoneerInstance({
                        beforeServerError: ( err ) => {

                            this.orderId = this.$route.query.o_id as string;
                            return this.handlePayoneerError( err );

                        },
                        proceedFunction: ( ...args ) => {

                            this.handlePayoneerData( ...args );

                        },
                    });
                    this.payoneerInit = true;

                } catch ( error ) {

                    console.error( 'Payoneer initialization failed:', error );
                    this.payoneerEnable = false;
                    unfoldError( 'errors.network_error' );

                }

            }

            if ( this.adyenEnable ) {

                try {

                    await payManager.createAdyenInstance(
                        this.orderObj,
                        ( ...args ) => {

                            this.queryResult( ...args );

                        },
                        () => {

                            unfoldError( 'order_complete.fail_reason2', 999999 );
                            this.goCompletePage();

                        }
                    );
                    this.adyenDisabledTypes =
                        payManager.adyenDisabledPaymentTypes;
                    this.adyenInit = true;

                } catch ( error ) {

                    console.error( 'Adyen initialization failed:', error );
                    this.adyenEnable = false;
                    unfoldError( 'errors.network_error' );

                }

            }

        },

        async initOrderDetails() {

            try {

                this.orderObj = await getOrderDetailById( this.orderId );
                this.orderItems = this.orderObj.items[0];
                this.mode = this.orderItems.context.action;
                this.orderPreviewInit = true;

            } catch ( error ) {

                console.error( 'get order failed', error );
                let symbol = ( error as AxiosError ).response?.data.error.symbol;
                if ( symbol === 'order_not_found' ) {

                    // 不是当前用户的订单，跳转到历史页

                    router
                        .push( '/user/cloud-plan-payment-history/' )
                        .catch( console.error );

                }

            }

        },
        async statusHandle( sessionId: string, isPaymentId?: boolean ) {

            console.log( 'status handle' );
            if ( this.paySessionStatus === EPaymentSessionStatus.PROCESSING ) {

                this.queryResult( sessionId, isPaymentId );

            } else {

                let res = await getOrderDetailById( this.orderId );

                this.orderStatus = res.status.paymentStatus;
                // 订单正在发货、payoneer支付完成但是后端没有收到通知
                // 轮询订单
                if (
                    this.orderStatus === orderPaymentStatus.PROCESSING ||
                    ( this.orderStatus === orderPaymentStatus.CREATED &&
                        ( this.paySessionStatus ===
                            EPaymentSessionStatus.COMPLETED ||
                            this.paySessionStatus ===
                                EPaymentSessionStatus.PENDING ))
                ) {

                    this.queryResult( sessionId );

                } else {

                    /**
                     * 其他情况
                     *
                     * 直接跳转到complete页面
                     */
                    if ( window.localStorage ) {

                        window.localStorage.setItem(
                            `order_done_${this.orderId}`,
                            this.orderId
                        );

                    }
                    let pathObject: Record<string, any> = {
                        path: '/checkout/payment-complete/',
                        query: {
                            id: this.orderId,
                            platform: config.platform,
                            mode: this.mode,
                            pp_id: this.prevPlan,
                        },
                    };
                    if ( this.payError ) {

                        pathObject.query.error = this.payError;

                    }
                    await router.push( pathObject )?.catch( console.error );

                }

            }

        },
        queryResult( sessionId: string, isPaymentId?: boolean ) {

            /**
             * 第一次间隔2s
             *
             * 第二次间隔5s
             *
             * 之后每次间隔30s
             */
            this.querying = true;
            console.log( 'query result' );
            if ( this.interval === 0 ) {

                this.interval = 2000;

            } else if ( this.interval === 2000 ) {

                this.interval = 5000;

            } else {

                this.interval = 30000;

            }
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            this.timer = window.setTimeout( async () => {

                try {

                    let result = await queryPaymentResult(
                        this.orderId,
                        sessionId,
                        isPaymentId
                    );
                    this.paySessionStatus = result.status;
                    this.redirectUrl = result.redirectUrl;

                } catch ( err ) {

                    const symbol = ( err as AxiosError ).response?.data?.error?.symbol;
                    if ( symbol === 'order_expired' ) {

                        unfoldError( 'order_complete.fail_reason2', 999999 );
                        this.goCompletePage();
                        return;

                    }
                    unfoldError( 'errors.server_error' );
                    console.error( err );

                }
                await this.statusHandle( sessionId, isPaymentId );

            }, this.interval );

        },
        goCompletePage() {

            window.clearTimeout( this.timer! );
            router
                .push({
                    path: '/checkout/payment-complete/',

                    query: {
                        id: this.orderId,
                        platform: this.config.platform,
                        mode: this.mode,
                        pp_id: this.prevPlan,
                    },
                })
                .catch( console.error );

        },
        /**
         * 通过localStorage监听多个tab页的支付完成事件
         */
        orderCompleteListener() {

            let cb: ( this: Window, ev: StorageEvent ) => void = (
                event
            ): void => {

                if (
                    event.key === `order_done_${this.orderId}` &&
                    event.newValue === this.orderId
                ) {

                    window.removeEventListener( 'storage', cb );
                    if (
                        window.localStorage.getItem(
                            `order_done_${this.orderId}`
                        )
                    ) {

                        window.localStorage.removeItem(
                            `order_done_${this.orderId}`
                        );

                    }
                    router
                        .push({
                            path: '/checkout/payment-complete/',

                            query: {
                                id: this.orderId,
                                platform: config.platform,
                                mode: this.mode,
                                pp_id: this.prevPlan,
                            },
                        })
                        .catch( console.error );

                }

            };
            if ( window.localStorage ) {

                window.addEventListener( 'storage', cb );

            }

        },
        /**
         * 拦截浏览器回退按钮
         */
        popStateListener() {

            this.popStateCb = async () => {

                if ( this.currentPopState ) {

                    return;

                }

                if ( this.mode !== ESubscribeMode.RENEW ) {

                    if (
                        this.orderObj.items[0].productType ===
                        ESeriesCategory.CLOUD_STORAGE_PLAN
                    ) {

                        let data = await getPlanById(
                            this.orderObj.items[0].productId
                        );
                        let name = '';
                        let query: Record<string, string> = {
                            loc: data.series.storageRegion,
                            model: data.series.deviceGroup,
                        };
                        if ( this.mode === 'create' ) {

                            name = 'subscribe-cloud';

                        } else if ( this.mode === 'switch' ) {

                            name = 'update-cloud';
                            query.ps_id =
                                this.orderObj.items[0].context.subscription!;

                        }
                        try {

                            await router.push({
                                name,
                                query,
                            });

                        } catch ( error ) {

                            console.error( error );

                        }

                    } else if (
                        this.orderObj.items[0].productType ===
                        ESeriesCategory.CLOUD_DATA_ADD_ON_PLAN
                    ) {

                        await router.push({
                            path: '/user/subscribe-plan/sim/choose',
                            query: {
                                isAddOn: 'true',
                                ymh: uidHandler.encrypt(
                                    this.orderObj.items[0].context
                                        .associateSimCards![0].iccid
                                ),
                                s_id: this.orderObj.items[0].context
                                    .parentSubscription as string,
                            },
                        });

                    } else if (
                        this.orderObj.items[0].productType ===
                            ESeriesCategory.CLOUD_STORAGE_DATA_PLAN ||
                        this.orderObj.items[0].productType ===
                            ESeriesCategory.CLOUD_DATA_PLAN
                    ) {

                        history.go( -1 );
                        this.currentPopState = true;

                    } else {

                        try {

                            await router.push({
                                path: '/user/subscribe-plan/sim/choose',
                                query: {
                                    ymh: uidHandler.encrypt(
                                        this.orderObj.items[0].context
                                            .associateSimCards![0].iccid
                                    ),
                                },
                            });

                        } catch ( error ) {

                            console.error( error );

                        }

                    }

                }

            };

            window.addEventListener( 'popstate', this.popStateCb );

        },
        showPayoneerError( msg: string ) {

            this.payoneerError = msg;
            apmMonitor.setTransactionOutcome( 'failure' );

        },
        handlePayoneerError( err: string | Record<string, any> ) {

            console.error( err );
            if ( typeof err === 'object' && err.interaction?.code ) {

                switch ( err.interaction.code ) {

                    case 'ABORT': {

                        if ( err.resultInfo === 'Payment session not found' ) {

                            Async.invokeAsync( async () => {

                                let res = await getOrderDetailById(
                                    this.orderId
                                );

                                if (
                                    res.status.paymentStatus ===
                                    orderPaymentStatus.CREATED
                                ) {

                                    await cancelPayment( this.payoneerSessionId );
                                    let { url } =
                                        await this.createPayoneerSession();
                                    // 此时payoneerSDK状态为loading，使用setTimeout延迟执行
                                    setTimeout(() => {

                                        payManager.payoneerInstance?.rerender(
                                            url
                                        );

                                    }, 0 );

                                } else {

                                    this.orderStatus = res.status.paymentStatus;
                                    await this.statusHandle(
                                        this.payoneerSessionId
                                    );

                                }

                            });

                        }

                        if (
                            err.interaction.reason === 'SYSTEM_FAILURE' &&
                            err.resultInfo ===
                                'We encountered a problem connecting to the server'
                        ) {

                            unfoldError(
                                this.$tc(
                                    'pay.payoneer_errors.retry.text_something_went_wrong'
                                ),
                                100000
                            );

                        }

                    }

                }

            } else if ( typeof err === 'string' ) {

                unfoldError(
                    this.$tc(
                        'pay.payoneer_errors.retry.text_something_went_wrong'
                    ),
                    100000
                );

            }

            return true;

        },
        handlePayoneerData( data: any ) {

            if ( this.$route.name !== 'pay' ) {

                return;

            }

            apmMonitor.startOrRenameTransaction(
                this.transactionNames.LEVEL1_ORDER_PAY_PAYONEER,
                EApmTransactionType.PAYMENT_PROCESS
            );

            let reason = data.interaction.reason;
            const code = data.interaction.code;
            switch ( code ) {

                case 'PROCEED':
                    // 当交互代码为 “PROCEED” 时，代码将显示在此处
                    this.paySessionStatus = EPaymentSessionStatus.COMPLETED;
                    this.payoneerError = '';
                    payManager.cleanup();
                    Async.invokeAsync(() =>
                        this.statusHandle( this.payoneerSessionId )
                    );

                    break;

                case 'ABORT':
                case 'ABORT-COMMON': {

                    // 当交互代码为 “ABORT”时，代码将显示在此处

                    // "DUPLICATE_OPERATION"
                    // 首次支付已成功，现已发出重复的前端 CHARGE 请求。
                    // 不显示错误信息，但显示已向用户支付成功。
                    if ( reason === 'DUPLICATE_OPERATION' ) {

                        this.paySessionStatus = EPaymentSessionStatus.COMPLETED;
                        this.payoneerError = '';

                    } else {

                        Async.invokeAsync( async () => {

                            await cancelPayment( this.payoneerSessionId );

                        });
                        this.paySessionStatus = EPaymentSessionStatus.CANCELLED;
                        // abort只传递错误值，不显示横幅错误
                        if ( reason !== 'NO_NETWORKS' ) {

                            this.payoneerError = `[${this.$tc(
                                'pay.payoneer_errors.abort.title_common'
                            )}] ${this.$tc(
                                'pay.payoneer_errors.abort.text_common'
                            )}`;

                        } else {

                            this.payoneerError = `${this.$tc(
                                'pay.payoneer_errors.retry.text_something_went_wrong'
                            )}`;

                        }

                    }

                    break;

                }
                case 'TRY_OTHER_ACCOUNT': {

                    switch ( reason ) {

                        case 'CUSTOMER_ABORT':
                        case 'INVALID_ACCOUNT':
                        case 'EXCEEDS_LIMIT':
                            this.showPayoneerError(
                                `[${this.$tc(
                                    `pay.payoneer_errors.try_other_account.title_${reason.toLowerCase()}`
                                )}] ${this.$tc(
                                    `pay.payoneer_errors.try_other_account.text_${reason.toLowerCase()}`
                                )}`
                            );
                            break;
                        case 'EXPIRED_ACCOUNT':
                            this.showPayoneerError(
                                `${this.$tc(
                                    `pay.payoneer_errors.try_other_account.text_${reason.toLowerCase()}`
                                )}`
                            );
                            break;
                        default:
                            this.showPayoneerError(
                                `[${this.$tc(
                                    'pay.payoneer_errors.try_other_account.title_common'
                                )}] ${this.$tc(
                                    'pay.payoneer_errors.try_other_account.text_common'
                                )}`
                            );

                    }

                    break;

                }
                case 'VERIFY':
                case 'RETRY-EXPIRED-SESSION':
                case 'RETRY': {

                    // 当交互代码为 “TRY_OTHER_ACCOUNT” 或“RETRY” 时，代码将显示在此处
                    switch ( reason ) {

                        case 'EXPIRED_SESSION':
                            Async.invokeAsync( async () => {

                                let res = await getOrderDetailById(
                                    this.orderId
                                );
                                if (
                                    res.status.paymentStatus ===
                                    orderPaymentStatus.CREATED
                                ) {

                                    let { url } =
                                        await this.createPayoneerSession();
                                    this.paymentSDK?.payoneer?.rerender( url );
                                    this.showPayoneerError(
                                        `${this.$tc( 'errors.payment_expired' )}`
                                    );

                                } else {

                                    this.orderStatus = res.status.paymentStatus;
                                    await this.statusHandle(
                                        this.payoneerSessionId
                                    );

                                }

                            });

                            break;
                        case 'TRUSTED_CUSTOMER':
                        case 'UNKNOWN_CUSTOMER':
                        case 'ACCOUNT_NOT_ACTIVATED':
                        case 'DECLINED':
                        case 'INVALID_REQUEST':
                            this.showPayoneerError(
                                `[${this.$tc(
                                    'pay.payoneer_errors.retry.title_common'
                                )}] ${this.$tc(
                                    'pay.payoneer_errors.retry.text_common'
                                )}`
                            );
                            break;

                        default:
                            this.showPayoneerError(
                                `${this.$tc(
                                    'pay.payoneer_errors.retry.text_something_went_wrong'
                                )}`
                            );

                    }

                    break;

                }

                case 'TRY_OTHER_NETWORK': {

                    switch ( reason ) {

                        case 'NETWORK_FAILURE':
                        case 'INVALID_REQUEST':
                            this.showPayoneerError(
                                `[${this.$tc(
                                    `pay.payoneer_errors.try_other_network.title_network_failure`
                                )}] ${this.$tc(
                                    `pay.payoneer_errors.try_other_network.text_network_failure`
                                )}`
                            );
                            break;

                        default:
                            this.showPayoneerError(
                                `[${this.$tc(
                                    'pay.payoneer_errors.try_other_network.title_common'
                                )}] ${this.$tc(
                                    'pay.payoneer_errors.try_other_network.text_common'
                                )}`
                            );

                    }
                    break;

                }

            }

        },
        getAdyenType( paymentMethod: string ) {

            return paymentMethod.replace( 'adyen.', '' );

        },
    },
    computed: {
        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },
        lang(): string {

            return this.$store.getters.lang;

        },
        currentPlanType(): ESeriesCategory | undefined {

            return this.orderItems?.productType;

        },
        currentPlanTypeSuffer(): string {

            return this.currentPlanType === ESeriesCategory.CLOUD_STORAGE_PLAN
                ? 'Cloud Storage Service'
                : 'sim list';

        },
    },
    watch: {
        $route: {
            async handler( to: Route ) {

                this.orderId = to.query.o_id as string;
                if ( to.query.o_id !== this.orderId ) {

                    await this.initOrderDetails();

                }

            },
            immediate: true,
        },
    },
    destroyed() {

        window.clearTimeout( this.timer! );
        window.removeEventListener( 'popstate', this.popStateCb! );

        // 移除Adyen点击事件监听器
        if ( this.adyenClickHandler ) {

            document.removeEventListener( 'click', this.adyenClickHandler );

        }

        payManager.cleanup();
        if ( window.localStorage.getItem( `order_done_${this.orderId}` )) {

            window.localStorage.removeItem( `order_done_${this.orderId}` );

        }

    },
});
</script>

<style lang="less" scoped>
.checkout {
    padding: 0.6rem 0;

    @media @snapeak_mobile {
        padding: 0;
    }

    &.app .checkout-container {
        padding-bottom: 0.5rem;
    }

    .checkout-container {
        max-width: 1200px;
        margin: 0 auto;
        background-color: @bg_02;
        padding: 60px 0;
        border-radius: 12px;

        @media @snapeak_mobile {
            padding: 20px 0 0;
        }

        #smart-button-payment {
            width: 280px;
            margin: 0 auto;

            @media @snapeak_mobile {
                width: unset;
            }

            @media screen and (min-width: 800px) {
                width: 280px;
            }

            /deep/ iframe.component-frame {
                z-index: 14;
            }
        }
        .power-by {
            color: @font_primary;
            line-height: 1.2;
            font-size: 16px;
            text-align: center;
            margin-top: 16px;
            @media @snapeak_mobile {
                font-size: 0.28rem;
            }
            &.paypal {
                color: @font_secondary;
                margin-top: 7px;
                text-align: center;
            }
        }

        .cart-bottom {
            @media @snapeak_pc {
                max-width: 600px;
                margin: 0 auto;
            }
        }
    }
}

.payment-methods-container {
    margin-bottom: 60px;
    @media @snapeak_mobile {
        margin: 0 15px 50px;
    }
    .title {
        text-align: center;
        color: @font_primary;
        margin-bottom: 0.3rem;
        @media @snapeak_mobile {
            margin-bottom: 0.52rem;
        }
        .main-title {
            font-size: 24px;
            line-height: 1.2;
            margin-bottom: 0.2rem;
            font-weight: 500;
            @media @snapeak_mobile {
                font-size: 0.28rem;
                margin-bottom: 0.24rem;
            }
        }
        .des {
            font-size: 16px;
            @media @snapeak_mobile {
                font-size: 0.28rem;
            }
        }
    }

    .separator {
        width: 280px;
        color: #666;
        margin-top: 0.24rem;
        margin-bottom: 0.24rem;
        @media @snapeak_mobile {
            width: 5rem;
            margin-top: calc(0.54rem - 12px);
            margin-bottom: 0.54rem;
        }
    }

    .adyen-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 280px;
        margin: 16px auto 0px;
        .mobile({
            width: 100%;
        });

        @media screen and (min-width: 800px) {
            width: 280px;
        }

        & > div {
            max-width: 280px;
            margin: 0 auto;
            width: 100%;
            @media @snapeak_mobile {
                width: 100%;
                max-width: none;
            }

            @media screen and (min-width: 800px) {
                width: 280px;
            }
        }
    }

    .payoneer-container {
        margin: 0.14rem auto 0;
        width: 6rem;
        display: flex;
        flex-direction: column;

        @media @mobile {
            width: unset;
        }

        .initBtn-container {
            &.showPayoneer {
                margin-bottom: 0.6rem;
            }
            text-align: center;

            #initPayoneerBtn {
                width: 2.8rem;
                margin: 0 auto;
                background: #006184;
                border-radius: 4px;

                @media @mobile {
                    width: 100%;
                }

                img {
                    vertical-align: text-bottom;
                    height: 0.22rem;

                    @media @mobile {
                        height: 0.32rem;
                    }
                }

                .text {
                    margin-left: 0.06rem;

                    @media @mobile {
                        font-size: 0.32rem;
                    }
                }
            }

            .power-by {
                margin-top: 0.12rem;
                @media @mobile {
                    margin-top: 0.16rem;
                }
            }
        }

        & /deep/ #submitBtnContainerId {
            text-align: center;
            @media @mobile {
                margin-top: 0.4rem;
            }
            #submitBtnId {
                width: 2.8rem;
                margin: 0 auto;
                @media @mobile {
                    width: 5rem;
                }
            }
        }

        .error {
            font-weight: 500;
            text-align: center;
            margin-bottom: 16px;
        }
    }

    .payoneer-container {
        margin: 0.14rem auto 0;
        width: 6rem;
        display: flex;
        flex-direction: column;

        @media @mobile {
            width: unset;
        }

        .initBtn-container {
            &.showPayoneer {
                margin-bottom: 0.6rem;
            }
            text-align: center;

            #initPayoneerBtn {
                width: 2.8rem;
                margin: 0 auto;
                background: #006184;

                @media @mobile {
                    width: 100%;
                }

                img {
                    vertical-align: text-bottom;
                    height: 0.22rem;

                    @media @mobile {
                        height: 0.32rem;
                    }
                }

                .text {
                    margin-left: 0.06rem;

                    @media @mobile {
                        font-size: 0.32rem;
                    }
                }
            }

            .power-by {
                margin-top: 0.12rem;
                @media @mobile {
                    margin-top: 0.16rem;
                }
            }
        }

        & /deep/ #submitBtnContainerId {
            text-align: center;
            @media @mobile {
                margin-top: 0.4rem;
            }
            #submitBtnId {
                width: 2.8rem;
                margin: 0 auto;
                @media @mobile {
                    width: 5rem;
                }
            }
        }
    }
}

.processing {
    & /deep/ .blinking {
        background-color: @bg_02;
    }
}
</style>

<style lang="less">
.reo-payment-methods-container .reo-payment-btn.reo-adyen-method-btn {
    user-select: none;
}
.reo-payment-methods-container
    .reo-payment-btn.reo-adyen-method-btn
    .adyen-checkout__applepay__button {
    width: 100%;
}
.reo-payment-methods-container .reo-payment-btn.reo-adyen-method-btn img {
    width: 80px;
    margin-right: 10px;
}
.reo-payment-methods-container
    .reo-payment-btn.reo-adyen-method-btn[payment-type="scheme"] {
    background-color: #ededed;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: @border-radius-level-small;
    padding: 8px 0;
    cursor: pointer;
}
.reo-payment-methods-container
    .reo-payment-btn.reo-adyen-method-btn[payment-type="scheme"]
    img {
    width: auto;
    height: 36px;
}
.reo-payment-methods-container .reo-payment-btn span {
    font-size: 18px;
    font-weight: 500;
}
.reo-payment-methods-container #reo-adyen-scheme-secondary-btn,
.reo-payment-methods-container #submitBtnId {
    background-color: #0e6aff;
    color: #fff;
    width: 100%;
    border-radius: 5px;
    border: none;
}
#reo-adyen-scheme-secondary-btn {
    display: none;
}
.reo-payment-methods-container .reo-adyen-payment-form {
    max-width: ~"min(100%, 800px)";
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid @line;
    padding: 16px 0;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;

    @media screen and (min-width: 800px) {
        width: 400px;
        max-width: 400px;
    }
}
.reo-payment-methods-container .hide {
    display: none;
}

.paypal-container {
    margin-top: 16px;
}
</style>
